class InputAutosizeDirective {
    constructor($window, $timeout) {
        this.restrict = 'A';
        this.require = 'ngModel';
        this.$window = $window;
        this.$timeout = $timeout;
    }

    link(scope, element, attrs, ngModel) {
        let additionalOffset = 0;

        if (element[0].type == 'number')
            additionalOffset += 15;

        const resize = () => {
            let model = ngModel.$modelValue || '';
            model += '';
            let value = (model.length * 11) + additionalOffset;

            // console.log(`InputAutosizeDirective::resize [${model}]`, `${value}px`);

            element.css({
                width: value + 'px'
            });
        }

        resize();

        this.$timeout(() => {
            resize();
        }, 1500);

        angular.element(this.$window).on('resize', resize);

        scope.$watch(
            () => ngModel.$modelValue,
            (newValue) => {
                resize();
            }
        );

        scope.$on('$destroy', () => {
            angular.element(this.$window).off('resize', resize);
        });
    }

    static directiveFactory($window, $timeout) {
        'ngInject';
        return new InputAutosizeDirective($window, $timeout);
    }
}

export default InputAutosizeDirective;